<div [formGroup]="form">
  <div class="docnum">
    <label for="doc">Document Number <span [ngStyle]="{'color': 'maroon'}">(required)</span></label>
    <input type="text" id="doc" name="docnum" formControlName="docnum" maxlength="20" aria-describedby="docnum_error">
    <div id="docnum_error" class="help-block" role="alert">
      <span *ngIf="form.get('docnum').errors?.required && form.get('docnum').touched">Enter Document Number</span>
      <span *ngIf="form.get('docnum').errors?.pattern && form.get('docnum').touched">Use numbers in Document Number</span>
    </div>
  </div>
</div>
